import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AssetApiService } from 'src/app/api/asset/assetApiService';
import { CreateAssetCommand } from 'src/app/api/asset/createAssetCommand';
import { DeviceTypeDto } from 'src/app/api/asset/deviceTypeDto';

@Component({
    selector: 'create-asset',
    templateUrl: './create-asset.component.html',
    styleUrls: ['./create-asset.component.css'],
    standalone: false
})
export class CreateAssetComponent {
  createAssetCommand: CreateAssetCommand = new CreateAssetCommand();
  error: string = '';
  saving: boolean = false;
  deviceTypes: DeviceTypeDto[] = DeviceTypeDto.GetAvailableTypes();

  constructor(
    private router: Router,
    private assetApiService: AssetApiService
  ) { }

  onSubmit(): void {
    this.saving = true;
    this.assetApiService.createAsset(this.createAssetCommand)
      .subscribe({
        next: response => {
          this.router.navigateByUrl("/asset/" + response.assetId);
          this.saving = false;
        },
        error: error => {
          this.error = error.message;
          this.saving = false;
        }
      });
  }
}
